import { toast } from 'sonner';
import { getPublicWebOrigin, isCapacitorNative } from './platform';

export function buildSignUrl(signToken) {
  if (!signToken) return '';
  return `${getPublicWebOrigin()}/sign/${signToken}`;
}

function isShareCancel(err) {
  const name = err?.name || '';
  const msg = String(err?.message || '').toLowerCase();
  return (
    name === 'AbortError' ||
    msg.includes('cancel') ||
    msg.includes('dismiss') ||
    msg.includes('share canceled')
  );
}

/**
 * Partage un lien (share sheet native Capacitor / Web Share API),
 * sinon copie dans le presse-papiers. Toujours un feedback visible.
 */
export async function shareOrCopyUrl({ title, text, url, lang = 'fr' }) {
  if (!url) {
    toast.error(lang === 'fr' ? 'Lien indisponible' : 'Link unavailable');
    return false;
  }

  const shareText = text ? `${text}\n${url}` : url;

  if (isCapacitorNative()) {
    try {
      const { Share } = await import('@capacitor/share');
      await Share.share({
        title: title || 'SoumissionPro',
        text: shareText,
        url,
        dialogTitle: title || 'SoumissionPro',
      });
      return true;
    } catch (e) {
      if (isShareCancel(e)) return true;
      console.warn('[shareLink] Capacitor Share failed, trying clipboard:', e);
    }
  } else if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({
        title: title || 'SoumissionPro',
        text: text || undefined,
        url,
      });
      return true;
    } catch (e) {
      if (isShareCancel(e)) return true;
      console.warn('[shareLink] navigator.share failed, trying clipboard:', e);
    }
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      toast.success(lang === 'fr' ? '✓ Lien copié' : '✓ Link copied');
      return true;
    }
  } catch (e) {
    console.warn('[shareLink] clipboard failed:', e);
  }

  // Dernier recours : prompt pour permettre un copier-coller manuel
  try {
    window.prompt(lang === 'fr' ? 'Copiez ce lien :' : 'Copy this link:', url);
    return true;
  } catch {
    toast.error(lang === 'fr' ? 'Impossible de partager le lien' : 'Could not share the link');
    return false;
  }
}
